import { TaskActions } from 'actions';
import File from 'components/File';
import { GridCell, GridRow } from 'components/Grid';
import * as Icons from 'components/Material/SvgIcons';
import FileUpload from 'components/Widgets/FileUpload';
import { Colors, Shadow, Units } from 'Css';
import { LinearProgress, RaisedButton, TextField } from 'material-ui';
import React, { Component, PropTypes } from 'react';
import styles from './Styles';
import TaskFeedback from './TaskFeedback';

const css = oxygenCss({
  root: {
    boxShadow: Shadow[1],
    backgroundColor: Colors.theme.Light.card,
    padding: Units.base,
    margin: Units.base,
  },
  uploadButton: {
    paddingBottom: Units.base,
    margin: Units.base / 2,
  },
  userName: {
    marginLeft: Units.base,
    fontSize: 24,
    display: 'inline-block',
  },
  fileContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  file: {
    flexGrow: 0,
    flexShrink: 0,
    margin: Units.base,
    position: 'relative',
  },
});

const style = {
  removeButton: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
};

export default class TextTaskResult extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func,
  };

  state = {
    progress: 0,
    files: [],
    showGrading: false,
    answered: false,
  };

  correct = () => {
    let feedback;
    feedback = this.refs.feedback.getValue();
    TaskActions.assessTask(
      this.props.taskId,
      this.props.id,
      feedback,
      1,
      this.state.files
    );
    this.setState({ showGrading: false, answered: true });
  };

  incorrect = () => {
    const feedback = this.refs.feedback.getValue();
    TaskActions.assessTask(
      this.props.taskId,
      this.props.id,
      feedback,
      0,
      this.state.files
    );
    this.setState({ showGrading: false, answered: true });
  };

  attach(uploadedFiles) {
    for (let i = 0; i < uploadedFiles.length; i++) {
      for (let k = 0; k < this.state.files.length; k++) {
        if (uploadedFiles[i].file.id === this.state.files[k].id) {
          return;
        }
      }
    }
    if (uploadedFiles.length > 0) {
      const files = [
        ...this.state.files,
        ...uploadedFiles.map((file) => file.file),
      ];
      this.setState({ files });
    }
  }

  toggleGrade = () => {
    this.setState((state) => ({ showGrading: !state.showGrading }));
  };

  removeFile = (index) => {
    const files = [...this.state.files];
    files.splice(index, 1);
    this.setState({ files });
  };

  handleFeedbackChange = (e) => {
    const feedback = e.target.value;
    this.setState({ feedback });
  };

  progress(e) {
    this.setState({ progress: e.percent });
  }

  render() {
    let { user, body, feedback, canGrade, reader, created } = this.props;
    const { progress, files, showGrading } = this.state;
    let fileComponent, uploadProgress;
    const uploading = progress > 0 && progress < 100;
    let grading;
    let values = [];
    let feedbacks;
    let answers = [];
    if (body.value && body.value.length > 0) {
      if (typeof body.value === 'string') {
        answers.push([{ text: body.value }, Colors.text.Dark.default]);
      } else {
        body.value.forEach((answer) => {
          answers.push([{ text: answer }, Colors.text.Dark.default]);
        });
      }
    }
    fileComponent = (
      <div className={css.fileContainer}>
        {files.map((file, index) => {
          return (
            <div key={index} className={css.file}>
              <File url={file.url} caption={file.name} />
              <RaisedButton
                label={this.context.getIntlMessage('Remove')}
                fullWidth
                style={style.removeButton}
                onTouchTap={() => this.removeFile(index)}
              />
            </div>
          );
        })}
      </div>
    );
    if (this.props.bodyFiles) {
      answers.push([
        {
          text: (
            <div className={css.fileContainer}>
              {this.props.bodyFiles.map((file, index) => (
                <div key={index} className={css.file}>
                  <div>
                    <File url={file.url} caption={file.name} />
                  </div>
                </div>
              ))}
            </div>
          ),
        },
        Colors.text.Dark.default,
      ]);

      // answers.push([<File url={body.fileUrl} caption={body.fileName}/>, Colors.text.Dark.default]);
    }
    if (answers.length > 0) {
      values = (
        <TaskFeedback
          answers={answers}
          created={created}
          leftIcon={<Icons.SocialPersonOutline />}
        />
      );
    } else {
      values = (
        <TaskFeedback
          answers={[
            [
              { text: this.context.getIntlMessage('tasks.noAnswer') },
              Colors.Colors.red[800].material,
            ],
          ]}
          leftIcon={<Icons.ContentClear color={Colors.material.red[500].hex} />}
        />
      );
    }
    if (uploading) {
      uploadProgress = (
        <div style={styles.progress}>
          <LinearProgress mode="determinate" value={progress} />
        </div>
      );
    }
    if (
      (feedback && typeof feedback.grade === 'number') ||
      feedback.text ||
      (this.props.feedbackFiles && this.props.feedbackFiles.length > 0)
    ) {
      let leftIcon;
      if (feedback.grade) {
        leftIcon = <Icons.ActionDone color={Colors.material.green[500].hex} />;
      } else {
        leftIcon = <Icons.ContentClear color={Colors.material.red[500].hex} />;
      }
      feedbacks = (
        <TaskFeedback
          answers={[[feedback, Colors.text.Dark.default]]}
          leftIcon={leftIcon}
          files={this.props.feedbackFiles || []}
        />
      );
    }
    if (
      showGrading ||
      (!this.state.answered &&
        canGrade &&
        feedback &&
        !feedback.created &&
        typeof feedback.created_by !== 'number')
    ) {
      grading = (
        <div style={styles.buttonContainer}>
          <TextField
            ref="feedback"
            floatingLabelText={this.context.getIntlMessage(
              'tasks.provideFeedback'
            )}
            fullWidth
            multiLine
          />
          {fileComponent}
          {uploadProgress}
          <GridRow fluid>
            <GridCell size={12}>
              <div className={css.uploadButton}>
                <FileUpload
                  disabled={uploading}
                  multiple
                  fullWidth
                  onProgress={this.progress.bind(this)}
                  onSuccess={this.attach.bind(this)}
                  label={this.context.getIntlMessage('attachFile')}
                />
              </div>
            </GridCell>
          </GridRow>
          <GridRow fluid>
            <GridCell size={6}>
              <div style={styles.answer.correct}>
                <RaisedButton
                  backgroundColor={Colors.material.green[400].hex}
                  labelColor="white"
                  onTouchTap={this.correct}
                  fullWidth
                  label={this.context.getIntlMessage('tasks.correct')}
                />
              </div>
            </GridCell>
            <GridCell size={6}>
              <div style={styles.answer.incorrect}>
                <RaisedButton
                  backgroundColor={Colors.material.red[400].hex}
                  labelColor="white"
                  onTouchTap={this.incorrect}
                  fullWidth
                  label={this.context.getIntlMessage('tasks.incorrect')}
                />
              </div>
            </GridCell>
          </GridRow>
        </div>
      );
    }
    return (
      <div className={css.root}>
        {values}
        {feedbacks}
        {grading}
        {canGrade &&
          (this.state.answered ||
            (feedback && !!feedback.created && !!feedback.created_by)) && (
            <RaisedButton
              onTouchTap={() => {}}
              fullWidth
              onClick={this.toggleGrade}
              label={
                !showGrading
                  ? this.context.getIntlMessage('tasks.redoanswer')
                  : 'Close'
              }
            />
          )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/TextTaskResult.js